import React from 'react'
import styled from '@emotion/styled'
import SEO from 'src/components/seo'
import GlobalCSS from 'src/components/GlobalCSS'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import SubPageTopLayout from 'src/components/organisms/SubPageTopLayout'
import PaperIntroduction from 'src/components/organisms/whitepapers/PaperIntroduction'
import PaperForm from 'src/components/organisms/whitepapers/PaperForm'
import Header from 'src/components/organisms/Header'
import Footer from 'src/components/organisms/Footer'

type Props = {
  paperName: string
  enPaperName?: string
  intro?: string
  thumbnail: string
  feature1: string
  feature2: string
  feature3: string
  description: string
  hsFormId?: string
  formSrc?: string
  type?: string
}

const PaperPage = ({
  paperName,
  enPaperName,
  intro,
  thumbnail,
  feature1,
  feature2,
  feature3,
  description,
  hsFormId,
  formSrc,
  type
}: Props) => {
  return (
    <>
      <SEO
        title={`${paperName}をダウンロード`}
        description="企業とユーザーをつなげるカスタマーサクセスプラットフォームcommmune(コミューン)の資料集です。オンライン顧客接点(ユーザーコミュニティ)構築の基礎やコミュニティマーケティング入門などの、カスタマーサクセスを進化したいお客様に向けたお役立ち資料をご用意しています。"
        image={thumbnail ? thumbnail : ''}
      />
      <Container>
        <GlobalCSS />
        <Header />
        <SubPageTopLayout title={paperName} heading="DOWNLOAD" />
        <ContentsWrapper>
          <PaperIntroduction
            intro={intro}
            thumbnail={thumbnail}
            feature1={feature1}
            feature2={feature2}
            feature3={feature3}
            description={description}
          />
          <PaperForm hsFormId={hsFormId} formSrc={formSrc} type={type} />
        </ContentsWrapper>
        <Footer />
      </Container>
    </>
  )
}

const Container = styled.div`
  z-index: 0;
  position: relative;
  overflow: hidden;
`

export default PaperPage
